/* global ENV */
const Flights = require('od-apps/app.flights');
const Dynpack = require('od-apps/app.dynpack');
const Accommodations = require('od-apps/app.accommodations');
const handlerImports = require('od-apps/desktop.handlerImports');
const trackingUtils = require('od-modules/utils/tracking.utils');
const metricsHelper = require('./../tracking/metrics_helper');
const loginFactory = require('components/user_area/login/js/main');
const myPsd2PopupManagerFactory = require('components/psd2/psd2_popup_manager/js/main');
const dpErrorManagementFactory = require('components/alerts_and_banners/dp_error_management/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const {getRememberMeCookieField} = require('od-modules/utils/sso.utils');
const templatesManager = require('services/widget_basic_resources/templates_manager');
const dpresultsNavigation = require('od-modules/handlers/dpresults/navigation');
const shoppingCart = require('../modules/cart/cart');
const {setProductNameInSession} = require('../tracking/product_name');
const createFrontendShellHandlers = require('od-modules/frontend-shell/handlers');
const shellNavigate = require('od-modules/frontend-shell/navigate');
const frontendShell = require('od-modules/frontend-shell');
const loginMenu = require('od-modules/helpers/login_menu');
import userEventController from 'od-modules/frontend-shell/usersEventController';
import {MEMBERSHIP_MYTRIPS_REACTIVATION} from 'od-modules/utils/membership_constants';
import {
    membershipPagesAppChangePages,
    membershipPagesRouterMatches, membershipPagesSecurePages,
} from 'od-modules/helpers/membership/membershipPages/routerApp';
import {
    profilePagesAppChangePages,
    profilePagesRouterMatches, profilePagesSecurePages,
} from 'od-modules/helpers/profilePages/routerApp';

const openedClass = function() {
    return Odigeo.AB.isCssVariationHeaderDesktop ? 'opened prisma-btn-active' : 'opened';
};

if (Flights.checkCookies()) {
    var {didTabClose} = require('od-modules/utils/tab_manager/tab_status');
    var BuyPath = require('od-modules/buy_path/buy_path');
    var BuyPathResults = require('od-modules/buy_path/buy_path.results');
    var BuyPathCalendar = require('od-modules/buy_path/buy_path.calendar');
    var currentSearchSingletonModel = require('od-modules/models/current_search.singleton.model');
    var app = Odigeo.Utils.getAppInGlobalScope();
    var isDynpack = Odigeo.Utils.isRequestApp('dp');
    var isSecure = Odigeo.Utils.getWebProtocol() === 'https:';
    var $summaryPanel = $('.summary_panel');
    var $header = $('#header');
    const $contactHeader = $('.contact_header');
    const $supportAreaHeader = $('.support_area_header');
    var $footer = $('#footer-wrapper');
    var $myTripsHeadButton = $('.my_trips_head_button');
    var $brandMessage = $('.brand_message');
    var $offlineSalesHeader = $('#offline-sales-banner-header.offline-sales-banner-wrapper');
    var closeHeaderPopUps;
    const widgets = Odigeo.autoloadWidgets(Odigeo._.extend({
        stopoverQuantityFilter: ['stopover-quantity-filter-${0}', 'stopover_quantity_filter'],
        timeFilter: ['time-filter-${0}', 'time_filter'],
        airlinesFilter: ['airlines-filter-${0}', 'airlines_filter'],
        airportsFilter: ['airports-filter-${0}', 'airports_filter'],
        stopoverDurationFilter: ['stopover-duration-filter-${0}', 'stopover_duration_filter'],
        flightDurationFilter: ['flight-duration-filter-${0}', 'flight_duration_filter'],
    },
    !isDynpack
        ? {
            bookFlightManager: ['book-flight-manager', 'book_flight_manager'],
        }
        : {
            dpBookManager: ['dpbook-manager', 'dp_book_manager'],
        },
    ));
    const asyncWidgets = Odigeo.autoloadWidgetsAsync({
        getMessageLayer: ['error-message-layer', 'error_message_layer'],
        dpWaitingPage: ['dpwaiting-page', 'dp_waiting_page'],
        getFilterByCities: ['filter-by-cities', 'filter_by_cities'],
        getResultsManager: ['results-manager', 'resultsmanager'],
        getFiltersManager: ['filters-manager', 'filters_manager'],
    });
    const widgetLoader = createWidgetLoader({
        login: ['login-header', loginFactory],
        loginExpired: ['login-expired-login-form', loginFactory],
        psd2PopupManager: ['psd2-popup-manager', myPsd2PopupManagerFactory],
        getDpErrorManagement: ['dp-error-management', dpErrorManagementFactory],
    });
    const refreshHeader = (page) => {
        const supportAreaPages = Odigeo.AB.getSupportAreaNewExperience > 1
            ? [
                'tripdetails',
                'mytrips',
                'frequentpassengers',
                'loginexpired',
                'accountpreferences',
                'accountcreditcards',
                'register',
                'support-center',
                'home']
            : [];
        const hiddenPages = Odigeo.AB.getSupportAreaNewExperience > 1
            ? ['mytripslogin']
            : [];
        const changeSupportAreaHeaderVisibility = !supportAreaPages.includes(page);
        const isNeverVisible = hiddenPages.includes(page);
        $contactHeader.toggleClass('odf-hidden', isNeverVisible || !changeSupportAreaHeaderVisibility);
        $supportAreaHeader.toggleClass('odf-hidden', isNeverVisible || changeSupportAreaHeaderVisibility);
    };

    var previousSearchesHeaderWidget = function() {
        var widget = {execute: function() {}};
        if (!isSecure) {
            Odigeo.requireWidget('previous-searches-header', 'previoussearches', function(previousSearches) {
                widget = previousSearches;
            });
        }
        return widget;
    };
    var trackingNewSearch = require('../tracking/newsearchtracking')();

    var errorManagement = require('./generic');

    var sendUpsellMetric = function(metric) {
        if (Odigeo.History.getPageNameFromFragment() === 'xsellproductselection') {
            trackingUtils.trackEvent('errors', metric);
        }
    };
    var handleNoResultsError = function() {
        var $resultspageSection = $('#results').find('.resultspage_section');
        var labelOps = Odigeo.AB.noResultsCopyDesktop === 2 ? 'labelsearchops' : 'labelops';
        var labelNoResults = Odigeo.AB.noResultsCopyDesktop === 2 ? 'labelsearchnoresults' : 'labelnoresults';
        var labelChangeSearch = Odigeo.AB.noResultsCopyDesktop === 2 ? 'labelbutton-changesearch2' : 'labelbutton-changesearch';
        var texts = {
            resetBtn: $resultspageSection.data(labelChangeSearch),
            labelops: $resultspageSection.data(labelOps),
            labelnoresults: $resultspageSection.data(labelNoResults),
        };

        asyncWidgets.getResultsManager().execute('clearResults');
        Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
        Odigeo.trigger('collapseFilters');
        Odigeo.UIElements.showNoResultsPopup(texts);
        trackingUtils.trackEvent('searcher_flights_error', 'no_results_for_this_search_error');
    };

    if (!isDynpack) {
        metricsHelper.stopRenderMetric();
    }

    const modelErrorManagement = {
        pagesList: ['home', 'results', 'details', 'payment', 'confirmation'],
        seatmapSelectionWidget: {
            id: 'seatmap-selection-manager',
            name: 'seatmap_selection_manager',
        },
        error404: function() {
            Odigeo.Router.navigate('error');
        },
        error500: function() {
            sendUpsellMetric('500_internal_error');
            Odigeo.UIElements.showBrokenFlowError();
        },
        brokenFlowError: function(error) {
            let selectionAccommodationProductErrorMessage;
            let specifiedAccommodationKeyDifferentFromPreviouslySelectedCode;
            const metaErrorCode = 'INT-003';
            if (isDynpack) {
                selectionAccommodationProductErrorMessage = widgets.dpBookManager().get('selectionAccommodationProductErrorMessage');
            } else {
                selectionAccommodationProductErrorMessage = widgets
                    .bookFlightManager()
                    .get('selectionAccommodationProductErrorMessage');
                specifiedAccommodationKeyDifferentFromPreviouslySelectedCode = widgets
                    .bookFlightManager()
                    .execute('getSpecifiedAccommodationKeyDifferentFromPreviouslySelectedCode');
            }
            const isAccommodationError = !Odigeo.Utils.startsWith(error.message, selectionAccommodationProductErrorMessage) &&
                !Odigeo.Utils.startsWith(error.message, specifiedAccommodationKeyDifferentFromPreviouslySelectedCode);
            const hasToDisplayMetaBrokenFlow = !Odigeo.AB.isMetaSelectionEnabled || !Odigeo.Utils.startsWith(error.message, metaErrorCode);
            if (isAccommodationError || hasToDisplayMetaBrokenFlow) {
                Odigeo.UIElements.showBrokenFlowError('alert', true);
            }
        },
        sessionExpiredError: function() {
            Odigeo.UIElements.showSessionExpiredError('alert', true);
        },
        defaultError: function() {
            Odigeo.UIElements.showBrokenFlowError('alert', true);
        },
        hideLoading: function() {
            Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
            if (isDynpack) {
                asyncWidgets.dpWaitingPage().execute('deactivate');
            }
        },
    };

    const frontendShellEventController = createFrontendShellHandlers({
        modelErrorManagement,
        errorManagement,
    });

    // Override AJAX callbacks
    Odigeo._.extend(
        Odigeo.Model.prototype,
        modelErrorManagement,
        errorManagement
    );

    closeHeaderPopUps = function() {
        var psHeaderWidget = previousSearchesHeaderWidget();
        $('.header_menu_list').find('.opened').not('.prevent_close_on_tap').removeClass(openedClass());

        if (psHeaderWidget.execute('isLuckyLayerBeingShown')) {
            psHeaderWidget.execute('updateBubbleCount');
            psHeaderWidget.execute('reload');
        }
    };
    Odigeo.on('notification:openLayer', function() {
        var state = Odigeo.Session.get('messageOpen') === 'true';

        if (Odigeo.SessionScope.openNotification && !state) {
            Odigeo.Session.set('messageOpen', 'true');
            var $launcher = $('.notification_layer');
            var noReturnBookerNotification = $launcher.find('.notification_message.returnbooker_bags_and_seats_message.odf-hidden').length > 0;
            $launcher.trigger(Odigeo.Events.tap);

            if (noReturnBookerNotification) {
                setTimeout(function() {
                    if ($('.notification_layer:hover').length === 0) {
                        $launcher.trigger(Odigeo.Events.tap);
                    }
                }, 3000);
            }
        }
    });

    Odigeo.on('notification:closeHeaderDialogs', function() {
        $('.header_launcher').removeClass(openedClass());
    });

    // Ensure analytics-client-identification service is called after rentacar sets the _ga cookie
    setTimeout(() => {
        const {thirdPartyTracking} = require('@edreamsodigeo/frontend-tracking-agent');
        thirdPartyTracking?.identifyAnalyticsClient();
    }, 10000);

    const odigeoStartConfig = {
        settings: {
            isSearchExecuted: false,
            pathNames: {
                home: Odigeo.Settings.property('appContext') + '/',
                homeflights: '/',
                flights: Odigeo.Settings.property('appContext') + '/flights/',
                dp: Odigeo.Settings.property('appContext') + '/dp/',
                dynpack: Odigeo.Settings.property('appContext') + '/dynpack/',
                accommodation: Odigeo.Settings.property('appContext') + '/accommodation/',
                secure: Odigeo.Settings.property('appContext') + '/secure/',
                flightscheckout: Odigeo.Settings.property('appContext') + '/flights/checkout/',
                paymentform: Odigeo.Settings.property('appContext') + '/payment/form/',
                membershippages: Odigeo.Settings.property('appContext') + '/membership-pages/',
                supportarea: Odigeo.Settings.property('appContext') + '/support-area/',
                cancellations: Odigeo.Settings.property('appContext') + '/cancellations/',
                modifications: Odigeo.Settings.property('appContext') + '/modifications/',
                alternatives: Odigeo.Settings.property('appContext') + '/alternatives/',
                extras: Odigeo.Settings.property('appContext') + '/extras/',
                userauth: Odigeo.Settings.property('appContext') + '/user-auth/',
                profile: Odigeo.Settings.property('appContext') + '/profile/',
                primemembership: Odigeo.Settings.property('appContext') + '/prime/membership/',
            },
            sessionTimerInitPages: [
                'results',
                'payment',
                'details',
                'detailsloading',
                'confirmation',
                'frequentpassengers',
                'accountcreditcards',
                'accountpreferences',
                'mytrips',
                'xsellproductselection',
            ],
            sessionExpirePages: [
                'results',
                'payment',
                'details',
                'dpresults_accommodation_details',
                'detailsloading',
                'xsellproductselection',
            ],
            sessionExpirePagesOnLoad: [
                'payment',
                'details',
                'confirmation',
            ],
            sessionAboutToExpirePages: [
                'results',
                'payment',
                'details',
                'xsellproductselection',
            ],
            searchExpirePages: [
                'results',
                'detailsloading',
                'xsellproductselection',
            ],
            sessionLoginExpirePages: [
                'frequentpassengers',
                'accountcreditcards',
                'accountpreferences',
                'mytrips',
            ],
        },

        onBeforeWidgetLoading: function() {
            // Check validity of Storage.
            var searches = Odigeo.Storage.get('search-data');
            var travellers = Odigeo.Storage.get('travellers');
            var purgedSearches;
            var purgedTravellers;

            if (!Odigeo._.isNull(searches)) {
                purgedSearches = Flights.purgePreviousSearches(searches);
                Odigeo.Storage.set('search-data', JSON.stringify(purgedSearches));
            }

            if (!Odigeo._.isNull(travellers)) {
                purgedTravellers = Flights.purgeTravellers(travellers);
                Odigeo.Storage.set('travellers', JSON.stringify(purgedTravellers));
            }
        },
        onStart: function() {
            var switchHeaderIconsSelection;
            var returnToHome;
            var changeSubMenuIcon;
            var selectCurrentMenu;
            var sessionTimerInit;
            var _tracktEvent;
            var $el;
            var $window = $(window);
            var $page = $('#page');
            var $menus = $('.menu_list');
            var $subMenu;
            var $subMenuChild;
            var $current;
            var convertAppToIDPage = {
                home: 'home',
                dp: 'flighthotel',
                flights: 'flights',
            };
            var convertedToIDPage = convertAppToIDPage[app];
            var pageNameFromFragment = Odigeo.History.getPageNameFromFragment();
            var usabillaEvents = require('od-modules/usabilla/events');

            usabillaEvents();

            var openPage = function(e) {
                var $activeMenu = $menus.find('.current.menu_item');
                var $activeMenuPage = $activeMenu.data('view');
                var $activeMenuPageElement = $('#' + $activeMenuPage);

                $el = $(e.currentTarget);
                var page = $el.data('page');
                var view = $el.data('view');
                var url = $el.data('url');

                e.stopImmediatePropagation();
                if (!Odigeo._.isEmpty(page) || !Odigeo._.isEmpty(view) || !Odigeo._.isEmpty(url) || $el.children().hasClass('protocol_switch')) {
                    if (!Odigeo._.isEmpty($activeMenuPage) && $activeMenuPageElement[0] && $activeMenuPageElement[0].beforeLeavePageHandler) {
                        $activeMenuPageElement[0].beforeLeavePageHandler();
                    } else {
                        pageRedirect();
                    }
                }
            };

            var addCrossDomainTrackingParameters = function(e) {
                var $link = $(e.currentTarget).find('a');
                var linkUrl = !Odigeo._.isEmpty($link) ? $link.data('link') : '';
                if (!Odigeo._.isEmpty(linkUrl)) {
                    Odigeo.requireWidget('google-analytics', 'googleanalytics', function(googleanalytics) {
                        var decoratedUrl = googleanalytics.get('getUrlDecoratedWithCrossDomainParameters', linkUrl);
                        $link.attr('href', decoratedUrl);
                    });
                }
            };

            var pageRedirect = function() {
                var page = $el.data('page');
                var url = $el.data('url');
                var target = $el.data('target');
                var selected = $el.attr('id');
                var pagesOF = [
                    'menu_home',
                    'menu_flights',
                    'menu_flighthotel',
                ];

                if ($el.data('view') === 'myinfo') {
                    // Dirty hack to allow click propagation reach the <a> tag before layout hides
                    Odigeo._.delay(function() {
                        switchHeaderIconsSelection($el);
                    }, 400);
                } else if (!url) {
                    switchHeaderIconsSelection($el);
                }

                // Analytics: event tracking
                trackingUtils.trackEvent('header', 'menu_primary_' +
                    Odigeo.Utils.removeBlankSpaces($el.text()).toLowerCase(), Odigeo.History.getPageNameFromFragment());

                if (!Odigeo._.isEmpty(page)) {
                    Odigeo.Router.navigate(page);
                } else if (!Odigeo._.isEmpty(url)) {
                    if (target === '_blank') {
                        Odigeo.trigger('analytics:tracking', {
                            type: 'sendToPageBlank',
                            data: {
                                url: url,
                                goOutside: !Odigeo._.includes(pagesOF, selected),
                            },
                        });
                    } else {
                        Odigeo.trigger('analytics:tracking', {
                            type: 'sendToPageSelf',
                            data: {
                                url: url,
                                goOutside: !Odigeo._.includes(pagesOF, selected),
                            },
                        });
                    }
                }
            };

            switchHeaderIconsSelection = function($el) {
                $menus.find('.current').removeClass('current');
                $menus.find('.active').removeClass('active');
                $menus.find('.submenu').addClass('hidden');
                $el.addClass('current');
                changeSubMenuIcon($el);
            };

            changeSubMenuIcon = function($el) {
                var parent = $el ? $el.parent() : null;
                if ($subMenu) {
                    $subMenu.children('.menu_item_desc').remove();
                    $subMenu.removeClass('current').prepend($subMenuChild);
                    $subMenu.find('.menu_item').removeClass('hidden');
                    $subMenu = null;
                    $subMenuChild = null;
                }
                if (parent && parent.hasClass('submenu')) {
                    $subMenu = parent.parent();
                    $subMenuChild = $subMenu.children('.menu_item_desc').detach();
                    // Dirty hack to allow click propagation reach the <a> tag before layout hides
                    Odigeo._.delay(function() {
                        $el.addClass('hidden');
                        $subMenu.prepend($el.children().clone()).addClass('current');
                    }, 500);
                }
            };

            selectCurrentMenu = function() {
                $current = $menus.find('#menu_' + convertedToIDPage);
                $current.addClass('current');
            };

            returnToHome = function() {
                if (isSecure && isDynpack) {
                    Odigeo.Session.remove('before-page');
                    $('body').data('app', 'dp');
                }

                // Don't navigate if it's disabled
                if (!$(this).hasClass('disabled')) {
                    if ($('#page').attr('data-waiting') !== 'true') {
                        Odigeo.Session.set('page', 'home');
                        Odigeo.Utils.goToApplicationHome();
                    }
                }
                // Analytics: event tracking
                trackingUtils.trackEventWithCategory('header', 'header', 'logo_clicks');
            };

            $window.on('hashchange', function() {
                if (!Odigeo.Session.get('ipHotelReminderNagShown')) {
                    $('.dialog:visible').trigger('dialog:closeOnNavigate');
                    $('#nag_container:visible').trigger('lightbox:closeOnNavigate');
                    if (Odigeo.AB.isNewWarningPopup) {
                        $('.ui_dialog_box.opened').trigger('dialog:closeOnNavigate');
                    }
                }
            });

            sessionTimerInit = function() {
                var timerConst = Odigeo.Utils.sessionTimer.CONST;
                var addEventOnce = function(evName, callback) {
                    Odigeo.off(evName).on(evName, callback);
                };
                var addSessionAboutToExpireEvent = function() {
                    const options = Odigeo.AB.isNewWarningPopup ? {removeClass: openedClass()} : {};
                    addEventOnce(timerConst.SESSION_ABOUT_TO_EXPIRE_EVENT, function() {
                        widgetLoader.get('psd2PopupManager').get('isVisible').then((isPsd2Visible) => {
                            if (Odigeo.AB.isPrimeTimeoutPopUp) {
                                Odigeo.requireWidget('prime_timeout_popup_of2_container', 'prime_timeout_popup_of2_container', function(widget) {
                                    widget.execute('renderOF2Template');
                                });
                                return;
                            }
                        });
                    });

                    widgetLoader.get('psd2PopupManager').get('isVisible').then((isPsd2Visible) => {
                        if (!isPsd2Visible) {
                            Odigeo.UIElements.showHurryUpAlertInXmin({...options,
                                time: 600000});
                        }
                    });
                };
                // In https, the expiration is set to 60 min
                // if(location.protocol === 'https:') {
                Odigeo.Utils.sessionLifeTime = 1140;
                // }

                // About to expire message is set to be shown 10 min before expiry (if applies)
                Odigeo.Utils.timeBeforeExpireAlert = Odigeo.Utils.sessionTimerNagLongest ? 900 : 1020;

                if (Odigeo._.includes(Odigeo.Settings.property('sessionTimerInitPages'), Odigeo.History.getPageNameFromFragment())) {
                    addEventOnce('session:started', function() {
                        Odigeo.Utils.sessionTimer.start();
                    });

                    addEventOnce(timerConst.SESSION_EXPIRED_EVENT, function() {
                        sendUpsellMetric('expired_session');
                        Odigeo.UIElements.showSessionExpiredError('alert', true);
                    });

                    Odigeo.bind('session:loginexpiration', function() {
                        Odigeo.UIElements.showSessionLoginExpirationError();
                    });

                    addEventOnce('session:refreshed', function() {
                        Odigeo.Utils.sessionTimer.reset();
                    });

                    addEventOnce('session:stopped', function() {
                        Odigeo.Utils.sessionTimer.stop();
                    });

                    if (!Odigeo.AB.isTenMinutesPopupDisabled) {
                        addSessionAboutToExpireEvent();
                    }

                    if (Odigeo.AB.isNewWarningPopup &&
                        Odigeo.History.getPageNameFromFragment() !== 'xsellproductselection') {
                        Odigeo.Utils.sessionTimer.setTime(Odigeo.Utils.sessionLifeTime,
                            180);
                    } else if (Odigeo.History.getPageNameFromFragment() === 'xsellproductselection') {
                        Odigeo.Utils.sessionTimer.setTime(Odigeo.Utils.sessionLifeTime, 600);
                    } else {
                        Odigeo.Utils.sessionTimer.setTime(Odigeo.Utils.sessionLifeTime,
                            Odigeo.Utils.sessionLifeTime - Odigeo.Utils.timeBeforeExpireAlert);
                    }
                }
            };

            $page
                .on(Odigeo.Events.tap, function(e) {
                    if ($(e.target).closest('.prevent_close_on_tap').length === 0) {
                        closeHeaderPopUps();
                    }
                });
            $supportAreaHeader.on(Odigeo.Events.tap, () => {
                const currentPage = Odigeo.History.getPageNameFromFragment();

                trackingUtils.trackEvent(`${currentPage}_pb_access`, `click:support-area-header_pag:${currentPage}`, currentPage);
                widgetLoader.get('login').get('isLogged').then(() => {
                    if (currentPage === 'tripdetails') {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`sahome/${tdToken}`);
                    } else {
                        Odigeo.Router.navigate('sahome');
                    }
                });
            });

            Odigeo.on('closeAllPopUps', function() {
                closeHeaderPopUps();
            });

            Odigeo.Session.set('lastRouteChange', JSON.stringify(null));

            const isNavigationType = (navigationType) => {
                return Odigeo._.get(window, 'performance.navigation.type') === Odigeo._.get(window, `performance.navigation.${navigationType}`);
            };

            if (isNavigationType('TYPE_BACK_FORWARD') && Odigeo.Session.get('page') === 'confirmation') {
                Odigeo.Router.navigate('payment');
            }

            Odigeo.Session.set('messageOpen', 'false');

            Odigeo.bind('routeChange', function(info) {
                Odigeo.trigger('close:' + info.from.name);
                Odigeo.UIElements.hint.bindCloseHintsOnPageClick(info.to.name);
                Odigeo.Session.set('lastRouteChange', JSON.stringify(info));
                Flights.onRouteChange('details', info);
                widgetLoader.get('login').execute('isUserLogged');
            });
            Odigeo.UIElements.hint.bindCloseHintsOnPageClick(pageNameFromFragment);
            Odigeo.Router.bindAnyRoute((route, ...args) => {
                const page = Odigeo.Router.getRouteByEventName(route);
                refreshHeader(page);
                shellNavigate(frontendShell, page, args);
            });

            $menus.on(Odigeo.Events.mousedown, '.menu_item', Odigeo._.bind(addCrossDomainTrackingParameters, this));
            $menus.on(Odigeo.Events.tap, '.menu_item', Odigeo._.bind(openPage, this));

            if (!Odigeo.SessionScope.isBookingXSWhiteLabel) {
                $('#logo').on(Odigeo.Events.tap, returnToHome);
            }

            Odigeo.bind('pageRedirect', pageRedirect);
            Odigeo.bind('returnToHome', returnToHome);
            if ($menus.length) {
                selectCurrentMenu();
            }
            Odigeo.bind('fullStorage', function() {
                $('.home_main_layout').addClass('error');
            });

            Odigeo.on('page:beforeSwitch', function($toPage) {
                $page.removeClass(function(index, className) {
                    var waitingClass = 'waiting';
                    $(this).attr('class', className.indexOf(waitingClass) < 0 ? '' : waitingClass);
                }).addClass($toPage.attr('id'));
            });

            if (($page.data('isSessionAlive') === false) &&
                Odigeo._.includes(Odigeo.Settings.property('sessionExpirePagesOnLoad'), pageNameFromFragment)) {
                Odigeo.UIElements.showSessionExpiredError('alert', true);
            }

            Odigeo.Router.bindAnyRoute(sessionTimerInit);

            const flightsPaymentPage = 'payment';
            const flightsIntermediatePage = 'xsellproductselection';
            const pagesWithoutLogin = [flightsPaymentPage, flightsIntermediatePage, Odigeo.AB.getSupportAreaNewExperience > 1 ? 'mytripslogin': ''];

            const isPageWithoutLogin = () => pagesWithoutLogin.includes(loginMenu.getCurrentPage());

            const hideOf1LoginButtonWhen = (condition) => $('#login-wrapper').toggleClass('odf-hidden', condition);
            const hideOf2LoginButtonWhen = (condition) => $('#login-wrapper-of2').toggleClass('odf-hidden', condition);

            Odigeo.Router.bindAnyRoute(function() {
                const isOf2LoginEnabledPerCurrentPage = loginMenu.isPageWithOf2Login();
                hideOf2LoginButtonWhen(isPageWithoutLogin() || !isOf2LoginEnabledPerCurrentPage);
                hideOf1LoginButtonWhen(isPageWithoutLogin() || isOf2LoginEnabledPerCurrentPage);
            });

            Odigeo.Router.bindAnyRoute(function() {
                $brandMessage.toggleClass('odf-text-left', !Odigeo._.isEmpty($offlineSalesHeader.html()));
            });

            // bind header/footer events
            $('.header_help_link').off().on(Odigeo.Events.tap, function() {
                // Analytics: event tracking
                trackingUtils.trackEventWithCategory('header', 'header', 'help_clicks');
            });
            $('.footer_conditions_link').off().on(Odigeo.Events.tap, function() {
                // Analytics: event tracking
                trackingUtils.trackEventWithCategory('footer', 'footer', 'terms_and_conditions_clicks');
            });

            $('.header_secondary_menu').off().on(Odigeo.Events.tap, function() {
                var promo = $(this).data('promoLabel');

                trackingUtils.trackEvent('header', 'menu_secondary_' + promo, Odigeo.History.getPageNameFromFragment());
            });

            $('.survey_link').off().on(Odigeo.Events.tap, function() {
                // Analytics: event tracking
                trackingUtils.trackEvent('header', 'feedback_clicks', Odigeo.History.getPageNameFromFragment());
            });

            $('.od-notification-wrapper-item a').off().on(Odigeo.Events.tap, function() {
                // Analytics: event tracking
                trackingUtils.trackEventWithCategory('notification_center', 'header', 'notifications_center_notice_clicks');
            });

            $('.footer_bottom_link, .footer_bottom_links a').off().on(Odigeo.Events.tap, function(evt) {
                trackingUtils.trackEvent('footer', 'links_open_' +
                    Odigeo.Utils.removeBlankSpaces($(evt.target).text()).toLowerCase(), Odigeo.History.getPageNameFromFragment());
            });

            // Bind header
            // TODO find proper place for site-wide bindings
            var $headLaunchers = $('.header_launcher', '.header_menu_list');
            var $notificationCenterBubble = Odigeo.UIElements.enhanceBubbleNotification($('#header').find('.header_notificationcenter_bubble'));

            Odigeo._.each($headLaunchers, function(el) {
                var $el = $(el);
                var triggerEvt = $el.data('trigger');
                var $others = $headLaunchers.not($el);
                var $target;

                if (triggerEvt === 'hover') {
                    var timer = null;
                    $el.hover(function() {
                        Odigeo.UIElements.hint.hideAllHints();
                        clearTimeout(timer);
                        $el.addClass(openedClass());
                        $others.removeClass(openedClass());
                    }, function() {
                        timer = setTimeout(function() {
                            $el.removeClass(openedClass());
                        }, 150);
                    });
                } else {
                    $el.on(Odigeo.Events[triggerEvt], function(e) {
                        Odigeo.UIElements.hint.hideAllHints();

                        const $currentTarget = $(e.currentTarget);
                        const elementIsNotDisplayed = !$el.hasClass(openedClass());
                        const previousSearches = Odigeo.getWidgetByID('previous-searches-header');

                        if (!($('#login-header').find('.login_root').hasClass('logged-on') && $($el[0]).hasClass('login-info-wrapper'))) {
                            if ($currentTarget.hasClass('previoussearches_header')) {
                                if (Odigeo.AB.isCssVariationHeaderDesktop) {
                                    closeHeaderPopUps();
                                    if (!!previousSearches && previousSearches.execute('isLuckyLayerBeingShown')) {
                                        previousSearches.execute('reload');
                                        if (elementIsNotDisplayed) {
                                            $el.addClass(openedClass());
                                        }
                                    } else {
                                        if (elementIsNotDisplayed) {
                                            $el.addClass(openedClass());
                                        }
                                    }
                                } else {
                                    // Do not close notification center when removing a message
                                    // if (!$(e.target).parent().hasClass('close_notification')) {
                                    if (!!previousSearches && previousSearches.execute('isLuckyLayerBeingShown')) {
                                        previousSearches.execute('reload');
                                        $el.addClass(openedClass());
                                    } else {
                                        $el.toggleClass(openedClass());
                                    }
                                }

                                if (previousSearches) {
                                    // Hide bubble notification
                                    previousSearches.execute('hideBubbleNotification');
                                }
                            } else {
                                const repositionCallHelpTooltip = function($el) {
                                    if (Odigeo.AB.isCssVariationHeaderDesktop && $el.find('od-header-tooltip-info-call-center')) {
                                        const isOutOfViewport = function(elem) {
                                            // Get element's bounding
                                            const bounding = elem.getBoundingClientRect();

                                            // Check if it's out of the viewport on each side
                                            const out = {};
                                            out.top = bounding.top < 0;
                                            out.left = bounding.left < 0;
                                            out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
                                            out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
                                            out.any = out.top || out.left || out.bottom || out.right;
                                            out.all = out.top && out.left && out.bottom && out.right;

                                            return out;
                                        };

                                        // check if box outside of bounderies
                                        const $elem = $el.find('.od_prisma_help_dialog');

                                        if (isOutOfViewport($elem.get(0)).right) {
                                            $elem.toggleClass('odf-message-box-contextual-bottom-center')
                                                .toggleClass('odf-message-box-contextual-bottom-right');
                                        }
                                    }
                                };

                                if (Odigeo.AB.isCssVariationHeaderDesktop) {
                                    closeHeaderPopUps();
                                    if (elementIsNotDisplayed) {
                                        $el.addClass(openedClass());
                                    }
                                } else {
                                    $el.toggleClass(openedClass());
                                }

                                repositionCallHelpTooltip($el);
                                if (!!previousSearches && previousSearches.execute('isLuckyLayerBeingShown')) {
                                    previousSearches.execute('updateBubbleCount');
                                }
                            }
                            $others.removeClass(openedClass());
                            if ($el.hasClass('login-info-wrapper')) {
                                $('#login-header').find('.modal_view').toggleClass('active');
                            }
                        }

                        if ($el.find(' + .header_tooltip_countries').length > 0) {
                            $('.continent_header.unfolded').trigger(Odigeo.Events.tap);
                        }
                        if ($el.hasClass('notification_layer')) {
                            $notificationCenterBubble.trigger('hideBubble');
                            $target = $(e.target);
                            if ($target.hasClass('close_notification')) {
                                $target.parents('.notification_message').addClass('odf-hidden').removeClass('od-notification-message');
                                if (!$('.notification_message').is(':visible')) {
                                    $('.no_messages').removeClass('odf-hidden');
                                }
                            }

                            if ($el.hasClass(openedClass())) {
                                trackingUtils.trackEventWithCategory('notification_center', 'header', 'notification_center_open');
                            }
                        }
                        e.stopPropagation();
                    });
                }

                if (($target = $el.find('.header_dialog')).length || ($target = $el.next('.header_dialog')).length) {
                    $target.find('.header_tooltip_close').on(Odigeo.Events.tap, function() {
                        $el.removeClass(openedClass());
                    });

                    $target.find('.od-header-tooltip-call-title').find('a').on(Odigeo.Events.tap, function() {
                        trackingUtils.trackEvent('header', 'faq_clicks', Odigeo.History.getPageNameFromFragment());
                    });
                }
            });

            Odigeo.on('loading:show', function(index) {
                var funnelLegacy = Odigeo.Utils.getFunnelTrackingLegacy();
                // Tracking analytics for waiting pages
                Odigeo.requireWidget('google-analytics', 'googleanalytics', function(widget) {
                    var suffix = Odigeo.Session.get('payment3ds') === 'true' ? '-3dsecure' : '/' + index;
                    widget.execute('trackVirtualPage', {
                        page: 'waiting' + suffix,
                        funnel: true,
                        legacy: '/waitPage/paso' + index + funnelLegacy,
                    });
                });
                Odigeo.Session.set('payment3ds', false);
            });

            Odigeo.on('sessionExpireDialog:repeatSearch', function(currentPage) {
                const searchData = isDynpack ? Dynpack.getSearchData() : Flights.getSearchData();
                const prefix = isDynpack ? 'dp' : '';
                const page = prefix + 'results';
                const searchManagerID = prefix + 'search-manager';
                const widgetName = prefix + 'searchmanager';
                const stringifier = isDynpack ? Dynpack.searchParamsStringify : Flights.searchParamsStringify;

                Odigeo.UIElements.hideAllDialogs();

                searchData.then(function(data) {
                    const redirect = !Odigeo._.has(data, 'internalSearch') || data.internalSearch === false;
                    data = Odigeo._.extend(data, {
                        buyPath: isDynpack ? Dynpack.getBuyPath(currentPage) : 'FLIGHTS_EXPIRED_SEARCH_POPUP',
                        internalSearch: true,
                    });
                    if (Odigeo.AB.isErrorFlightSelectionRelaunchSearch && Odigeo.History.getPageNameFromFragment() === 'results') {
                        Odigeo.Router.navigate(page, {params: stringifier(data)});
                        $('.od-header-funnel-info, .od-home-resultpage-main, .od-page-titleandsearch, #reset_filters_container, #footer').addClass(
                            'odf-hidden'
                        );
                        Odigeo.Router.reload();
                    } else {
                        if (!redirect && currentPage === page) {
                            // Relaunch the search
                            Odigeo.requireWidget(searchManagerID, widgetName, function(searchManager) {
                                searchManager.execute('search', data);
                            });
                        } else {
                            // Dynpack special case.
                            // We need to update searchParameters to avoid losing buyPath
                            // when we come from a session expiry in roomselection.
                            if (currentPage === 'dpresults_accommodation_details') {
                                currentSearchSingletonModel.getInstance().set(data);
                            }
                            // Go to results
                            Odigeo.Router.navigate(page, {params: stringifier(data)});
                        }
                    }
                }, function() {
                    // Unable to retrieve the data, let the results page do the job
                    Odigeo.Router.navigate(page);
                });
            });

            $('.initial_loader').addClass('hidden');

            Odigeo.trigger('checkNewsletterVisibility');

            // Init previous searches widget from header
            Odigeo.on('previous-searches-header:rowSelected', function(search) {
                Odigeo.requireWidget('previous-searches-header', 'previoussearches', function(previousSearchesHeader) {
                    previousSearchesHeader.execute('searchMadeFromPreviousSearches');
                });
                search.buyPath = 'FLIGHTS_HOME_RECENT_SEARCHES';
                // Go to results, with the url constructed
                currentSearchSingletonModel.getInstance().set(search);
                Odigeo.Router.navigate('results', false, true, Flights.searchParamsStringify(search));
            });

            previousSearchesHeaderWidget();

            var $notificationHeader = $page.find('#notification-header');
            var $noMessage = $notificationHeader.find('.no_messages');
            var $messages = $notificationHeader.find('.notification_message:visible');
            var messageCount = $messages.length;
            if (messageCount > 0) {
                $noMessage.addClass('odf-hidden');
            }

            // SSO
            _tracktEvent = function(action, label) {
                // Analytics: event tracking
                trackingUtils.trackEventWithCategory('sso_module', action, label);
            };

            $('.top_menu_options').find('[data-page]').on(Odigeo.Events.tap, function(e) {
                var item = $(e.currentTarget);
                var page = item.data('page');
                var trackingLabel = item.data('tracking');

                _tracktEvent('header', trackingLabel);
                if (page === 'logout') {
                    widgetLoader.get('login').execute('openModalLogout', {data: '', action: 'logOut'});
                } else if (page === 'mytrips') {
                    Odigeo.Router.navigate(MEMBERSHIP_MYTRIPS_REACTIVATION);
                } else {
                    Odigeo.Router.navigate(page);
                }
            });

            function gotoLoginOrRegister(e) {
                var data = $(e.currentTarget).data();

                e.stopPropagation();
                _tracktEvent('header', data.tracking);
                if (data.action === 'login' || data.softLogin) {
                    Odigeo.Session.set('loginWidget', 'login-header');
                    widgetLoader.get('login').execute('openModalLogin');
                } else {
                    Odigeo.Router.navigate('user-register');
                }
            }

            $summaryPanel.find('.header_register_button, .header_login_button, .membership_soft_login ')
                .off().on(Odigeo.Events.tap, gotoLoginOrRegister);

            var isMembershipRememberMe = getRememberMeCookieField('isMembership') === 'true';

            if (isMembershipRememberMe) {
                $summaryPanel.off().on(Odigeo.Events.tap, gotoLoginOrRegister);
            }

            $myTripsHeadButton.off(Odigeo.Events.tap).on(Odigeo.Events.tap, function() {
                var page = $myTripsHeadButton.hasClass('my_trips_header_logged') ? 'mytrips' : 'mytripslogin';
                Odigeo.Router.navigate(page);
            });
            // END SSO

            widgetLoader.get('login');

            Odigeo.trigger('analytics:tracking', {
                type: 'trackCustomVariable',
                data: {
                    index: 37,
                    name: 'Beta',
                    value: $page.data('beta'),
                    scope: 2,
                },
            });

            Odigeo.trigger('trackMainPageView');

            if (Odigeo.AB.isCognitiveOverloadEnabled) {
                $('.od-home-resultpage-main').css({'margin': 'auto'});
            }
        },
        router: {
            routes: {}, // WARNING: these STRING routes will become regexps with leading ^ and trailing $.
            /* eslint-disable max-len, quote-props */
            routeMatches: {
                home: /^\/?(?:(?:travel\/(?:flights\/|dp\/))?home\/(.*)|travel\/(?:flights\/|dp\/)?|\/?)$/,
                resident: /^\/?(?:travel\/)?(?:flights\/)?resident\//,
                inspirational: /^\/?(?:travel\/)?(?:flights\/)?inspirational\//,
                results: /^\/?(?:travel\/)?(?:flights\/)?results\/(.*)/,
                xsellproductselection: /^\/?(?:travel\/)?(?:flights\/)?xsellproductselection\/(.*)/,
                detailsloading: /^\/?(?:travel\/)?(?:flights\/)?detailsloading\/(.*)/,
                dpresident: /^\/?(?:travel\/dp\/)?dpresident\//,
                dpresults_accommodation: /^\/?(?:travel\/dp\/)?(?:dpresults_accommodation)\/(.*)/,
                dpresults_flights: /^\/?(?:travel\/dp\/)?(?:dpresults_flights)\/(.*)/,
                dpresults_accommodation_details: /^\/?(?:travel\/dp\/)?(?:dpresults_accommodation_details)\/(.*)/,
                details: /^\/?(?:travel\/secure\/)?(?:details)\/(.*)/,
                payment: /^\/?(?:travel\/secure\/)?payment\/(.*)/,
                pbpayment: /^\/?(?:travel\/secure\/)?pbpayment\/(.*)/,
                payment3ds: /^\/?(?:travel\/secure\/)?payment3ds\/(.*)/,
                confirmation: /^\/?(?:travel\/secure\/)?confirmation\//,
                register: /^\/?(?:travel\/secure\/)?register\//,
                loginexpired: /^\/?(?:travel\/secure\/)?loginexpired\//,
                accountblocked: /^\/?(?:travel\/secure\/)?accountblocked\//,
                accountcreditcards: /^\/?(?:travel\/secure\/)?accountcreditcards\//,
                accountpreferences: /^\/?(?:travel\/secure\/)?accountpreferences\//,
                resetpassword: /^\/?(?:travel\/secure\/)?resetpassword\/(.*)/,
                frequentpassengers: /^\/?(?:travel\/secure\/)?frequentpassengers\/(.*)/,
                mytrips: /^\/?(?:travel\/secure\/)?mytrips\/(.*)/,
                mytripslogin: /^\/?(?:travel\/secure\/)?mytripslogin\/(.*)/,
                tripdetails: /^\/?(?:travel\/secure\/)?tripdetails\/(.*)/,
                tripdetails_booking_management: /^\/?(?:travel\/secure\/)?tripdetails_booking_management\/(.*)/,
                unavailablecheckin: /^\/?(?:travel\/secure\/)?unavailablecheckin\/(.*)/,
                'support-center': /^\/?(?:travel\/secure\/)?support-center\/(.*)/,
                attachment: /^\/?(?:travel\/secure\/)?attachment\/(.*)/,
                post_booking: /^\/?(?:travel\/secure\/)?post_booking\/(.*)/,
                primepostbooking: /^\/?(?:travel\/secure\/)?primepostbooking\/(.*)/,
                membership_password_setup: Odigeo.Membership.isMembershipPasswordSetupPage ? /^\/?(?:travel\/secure\/)?prime\/password-setup\/(.*)/ : null,
                membership_onboarding: Odigeo.Membership.isMembershipOnboardingPage ? /^\/?(?:travel\/secure\/)?prime\/onboarding\/(.*)/ : null,
                membership_renewal_reactivation: /^\/?(?:travel\/secure\/)?prime\/reactivation\/(.*)/,
                error: /\/?error\//,
                metaancillaries: /^\/?(?:travel\/secure\/)?metaancillaries\/(.*)/,
                ofpreload: /\/?ofpreload\//,
                dpredirect: /^\/?((?:travel\/dp\/)?(?:booking|dpresults|roomselection)|(?:travel\/secure\/)?(?:passengersinfo))\/(.*)/,
                odigeobook: (ENV === 'development') ? /^\/?(?:travel\/)?odigeobook\/(.*)/ : null,
                user_register: /^\/?(?:travel\/)?user-auth\/user-register\/(.*)/,
                ...profilePagesRouterMatches(),
                ...membershipPagesRouterMatches(),
            },
            /* eslint-enable max-len */

            handlerImports: handlerImports,
            globalEventsControllers: [userEventController],
            /**
             * Apps with pages that change to other apps (funnel change)
             */

            appChangePages: (function() {
                const membershipAppChangePages = membershipPagesAppChangePages();
                const profileAppChangePages = profilePagesAppChangePages();
                var configAppChangePages = {
                    home: {
                        home: 'home',
                        homeflights: 'homeflights',
                        dpresults_flights: 'dp',
                        dpresults_accommodation: 'dp',
                        dpresident: 'dp',
                    },
                    flights: {
                        homeflights: 'homeflights',
                    },
                    dp: {
                        homeflights: 'homeflights',
                        results: 'flights',
                        dpresident: 'dp',
                        resident: 'flights',
                    },
                    secure: {
                        home: 'home',
                        homeflights: 'homeflights',
                        results: 'home',
                        dpresults_flights: 'dp',
                        dpresults_accommodation: 'dp',
                        dpresults_accommodation_details: 'dp',
                        checkout_passengers: 'flightscheckout',
                        checkout_payment: 'flightscheckout',
                        ancillaries: 'flightscheckout',
                        prime_subscription: 'flightscheckout',
                        confirm_booking: 'flightscheckout',
                        sahome: 'supportarea',
                        'manage-my-booking': 'supportarea',
                        categories: 'supportarea',
                        contact: 'supportarea',
                        cnxsummary: 'cancellations',
                        cnxflightselector: 'cancellations',
                        cnxinfo: 'cancellations',
                        cnxlcc_flightselector: 'cancellations',
                        cnxlcc_summary: 'cancellations',
                        cnxslcc_stopovers: 'cancellations',
                        modifylc_your_flights: 'modifications',
                        modifylc_your_stopovers: 'modifications',
                        modifylc_change_trip: 'modifications',
                        modify_flightselector: 'modifications',
                        modify_paxselector: 'modifications',
                        modify_search: 'modifications',
                        modify_calendar: 'modifications',
                        modify_results: 'modifications',
                        modify_itinerary: 'modifications',
                        modify_summary: 'modifications',
                        modify_confirmation: 'modifications',
                        alt_intro: 'alternatives',
                        postbooking: 'extras',
                        checkin: 'extras',
                        booking_cancellation: 'primemembership',
                        ...profileAppChangePages.secure,
                        ...membershipAppChangePages.secure,
                        'user-register': 'userauth',
                    },
                    accommodation: {
                        home: 'home',
                        homeflights: 'homeflights',
                    },
                    profile: {
                        ...profileAppChangePages.profilepages,
                    },
                    membershippages: {
                        ...membershipAppChangePages.membershippages,
                    },
                    userauth: {
                        'user-register': 'user_register',
                    },
                };
                var securePages = {
                    loginexpired: 'secure',
                    accountblocked: 'secure',
                    details: 'secure',
                    register: 'secure',
                    payment: 'secure',
                    pbpayment: 'secure',
                    payment3ds: 'secure',
                    checkout_passengers: 'flightscheckout',
                    confirmation: 'secure',
                    resetpassword: 'secure',
                    frequentpassengers: 'secure',
                    accountcreditcards: 'secure',
                    accountpreferences: 'secure',
                    mytrips: 'secure',
                    mytripslogin: 'secure',
                    tripdetails: 'secure',
                    sahome: 'supportarea',
                    'manage-my-booking': 'supportarea',
                    categories: 'supportarea',
                    'support-center': 'secure',
                    attachment: 'secure',
                    post_booking: 'secure',
                    primepostbooking: 'secure',
                    membership_password_setup: 'secure',
                    membership_onboarding: 'secure',
                    membership_renewal_reactivation: 'secure',
                    cnxflightselector: 'cancellations',
                    cnxsummary: 'cancellations',
                    cnxinfo: 'cancellations',
                    cnxlcc_flightselector: 'cancellations',
                    cnxlcc_summary: 'cancellations',
                    cnxslcc_stopovers: 'cancellations',
                    modifylc_your_flights: 'modifications',
                    modifylc_your_stopovers: 'modifications',
                    modifylc_change_trip: 'modifications',
                    modify_flightselector: 'modifications',
                    modify_paxselector: 'modifications',
                    modify_search: 'modifications',
                    modify_calendar: 'modifications',
                    modify_results: 'modifications',
                    modify_itinerary: 'modifications',
                    modify_summary: 'modifications',
                    modify_confirmation: 'modifications',
                    alt_intro: 'alternatives',
                    'user-register': 'userauth',
                    booking_cancellation: 'primemembership',
                    ...profilePagesSecurePages(),
                    ...membershipPagesSecurePages(),
                };

                Odigeo._.extend(configAppChangePages.home, securePages);
                Odigeo._.extend(configAppChangePages.dp, securePages);
                Odigeo._.extend(configAppChangePages.flights, securePages);
                Odigeo._.extend(configAppChangePages.accommodation, securePages);

                return configAppChangePages;
            }()),
            handlers: $.extend(Odigeo.Router.handlers, {
                globalEventController: {
                    globalEvents: {},
                    eventHandlers: {},
                },
                userEventController,
                frontendShellEventController,
                errorManagerEventController: {
                    globalEvents: {
                        'payment-manager:manageError': 'onManageError',
                    },
                    // implementation of events handlers
                    eventHandlers: {
                        onManageError: function(error) {
                            asyncWidgets.getMessageLayer().execute('manageError', error);
                        },
                    },
                },
                repriceManagerEventController: {
                    globalEvents: {
                        'reprice-manager:checkRepricing': 'onCheckRepricing',
                        'reprice-manager:checkNoSecureRepricing': 'onCheckNoSecureRepricing',
                    },
                    // implementation of events handlers
                    eventHandlers: {
                        onCheckRepricing: function(repricingContainer) {
                            var $repricingNotification = $(repricingContainer);

                            $repricingNotification.load(
                                Odigeo.Settings.property('widgetUrlFormatter')('repricing-notification-payment', 'repricingnotification'),
                                function() {
                                    var $content = $repricingNotification.find('.repricing_notification_content');

                                    if ($content.length && parseFloat($content.data('amount')) !== 0) {
                                        if ($content.find('.is_repricing').length > 0) {
                                            Odigeo.trigger('global:repricingShown');
                                            $content.find('.close_repricing').on(Odigeo.Events.tap, function(e) {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                $content.addClass('hidden');
                                            });
                                        }
                                    }
                                }
                            );
                        },
                        onCheckNoSecureRepricing: function(event) {
                            var template = Odigeo._.template($('#nosecure-repricing-template').html(), {
                                evaluate: /\{\{#([\s\S]+?)\}\}/g,
                                interpolate: /\{\{[^#\{]([\s\S]+?)[^\}]\}\}/g, // eslint-disable-line no-useless-escape
                                escape: /\{\{\{([\s\S]+?)\}\}\}/g,
                                variable: 'repricing',
                            });
                            var diff = Odigeo._.get(event, 'data.diff', 0);
                            var quantity = Math.abs(diff);

                            $(event.container).html(template({
                                isPositiveRepricing: diff > 0,
                                hasToShowRepricing: quantity > 0.03,
                                quantity: Odigeo.Utils.formatCurrency(quantity, Odigeo._.extend({}, Odigeo.Utils.Currency, {decimalPlaces: 2})),
                            }));
                        },
                    },
                },
                searchFlightsEventController: {
                    // Global events will remain bound in any part of the application
                    globalEvents: {
                        'airlines-filter:update': 'updateAirlinesFilter',
                        'airports-filter:update': 'updateAirportsFilter',
                        'airport_selector:trackEvent': 'onTrackAutocomplete',
                        'change-search:search': 'onSearch',
                        'onelinebutton_search_manager:search': 'onSearch',
                        'calendar-grid:search': 'onSearch',
                        'change-search:searchCompletedSuccessfully': 'onSearchCompletedSuccessfully',
                        'change-search:searchCompletedWithError': 'onSearchCompletedWithError',
                        'change-search:searchError': 'onSearchError',
                        'change-search:searchPerformed': 'onSearchPerformed',
                        'dpchange-search:search': 'onDynpackSearch',
                        'filters-manager:allowToRefreshResults': 'allowToRefreshResults',
                        'filter-by-cities:init': 'initFilterByCities',
                        'filters-manager:check-non-stopover-filter': 'doCheckNonStopsFilter',
                        'flexible-dates:search': 'onSearch',
                        'flights-manager:dynpackSearch': 'onDynpackSearch',
                        'flights-manager:search': 'onFlightManagerSearch',
                        'inspirational-manager:search': 'onSearch',
                        'ipchange-search:dpSearch': 'onDynpackSearchFromFlights',
                        'ipchange-search:search': 'onSearch',
                        'resident-discount:search': 'onSearch',
                        'search-manager:analyticsTrackingEvents': 'onAnalyticsTrackingEvents',
                        'search-manager:prepareResultsManager': 'onPrepareResultsManager',
                        'search-manager:prepareCalendarGrid': 'onPrepareCalendarGrid',
                        'search-manager:prepareSearchSummary': 'onPrepareSearchSummary',
                        'search-manager:preSearchPerformed': 'onPreSearchPerformed',
                        'search-manager:searchCompletedSuccessfully': 'onSearchCompletedSuccessfully',
                        'search-manager:searchCompletedWithError': 'onSearchCompletedWithError',
                        'search-manager:searchError': 'onSearchError',
                        'search-manager:startMapiMetric': 'onStartMapiMetric',
                        'search-manager:searchMapiCompletedSuccessfully': 'onSearchMapiCompletedSuccessfully',
                        'search-manager:searchMapiCompletedWithError': 'onSearchMapiCompletedWithError',
                        'search-manager:showWaitingPage': 'onShowWaitingPage',
                        'search-manager:storeSearch': 'onStoreSearch',
                        'stopover-duration-filter:update': 'updateStopoverDurationFilter',
                        'time-filter:update': 'updateTimeFilter',
                        'flight-duration-filter:update': 'updateFlightDurationFilter',
                    },
                    // implementation of events handlers
                    eventHandlers: {
                        onSearch: function(data, resultPage, stringifierFun) {
                            var pageName = Odigeo.History.getPageNameFromFragment();
                            var $flightsManager = $('#flights-manager');
                            var isDynpackTabActive = $flightsManager.find('.flightsManager_tab.active').data('value') === 'dp' &&
                                pageName !== 'xsellproductselection';
                            var iatas;
                            var residentIATAs;
                            var internalSearchFlowConditions;
                            var residentZones = [];
                            var sameCountry = false;

                            resultPage = Odigeo._.isUndefined(resultPage) ? 'results' : resultPage;
                            var residentPage = resultPage === 'results' ? 'resident' : 'dpresident';
                            stringifierFun = Odigeo._.isFunction(stringifierFun) ? stringifierFun : Flights.searchParamsStringify;

                            if (trackingNewSearch.isValidPaymentMethod(data.collectionMethod)) {
                                trackingNewSearch.setAction('searcher_' + (isDynpackTabActive ? 'dynpack' : 'flights'));
                                trackingUtils.trackEvent(trackingNewSearch.action, trackingNewSearch.getPayMethodLabel(data));
                            }

                            if (pageName === 'home' && !isDynpackTabActive) {
                                delete data.checkInDate;
                                delete data.checkOutDate;
                            }

                            var params = Odigeo._.clone(data);

                            // Set buyPath
                            var resultsHomeBuyPathBuilder = new BuyPathResults(
                                resultPage,
                                Dynpack.getHomeBuyPath(isDynpack, isDynpackTabActive),
                                'FLIGHTS_HOME_SEARCH_FORM'
                            );
                            var resultsIntermediateBuyPathBuilder = new BuyPathResults(
                                resultPage,
                                'INTERMEDIATE_PAGE_DYNPACK_SEARCH',
                                'INTERMEDIATE_PAGE_FLIGHTS_SEARCH'
                            );

                            params.buyPath = {
                                'inspirational': new BuyPath('INSPIRATIONAL_SEARCH'),
                                '': resultsHomeBuyPathBuilder,
                                'home': resultsHomeBuyPathBuilder,
                                'flights': resultsHomeBuyPathBuilder,
                                'details': params.comesFromPassenger ?
                                    new BuyPath('PASSENGER_PAGE_SEARCH') : resultsHomeBuyPathBuilder,
                                'results': new BuyPathCalendar(params.isCalendarSearch),
                                'dpresults_accommodation': new BuyPath('DYNPACK_RESULTS_ACCOMMODATION_SEARCH_FORM'),
                                'dpresults_flights': new BuyPath('DYNPACK_RESULTS_FLIGHTS_SEARCH_FORM'),
                                'xsellproductselection': resultsIntermediateBuyPathBuilder,
                                'dpresults_accommodation_details': new BuyPath('DYNPACK_ROOM_SELECTION_SEARCH_FORM'),
                            }[pageName].build();

                            internalSearchFlowConditions = resultPage === dpresultsNavigation.getFirstRoute() &&
                                (pageName === '' || pageName === 'flights' || pageName === 'home');

                            if (internalSearchFlowConditions) {
                                params.internalSearch = internalSearchFlowConditions;
                            }

                            params.internalSearch = Odigeo.SessionScope.isFromAirlineWMP || params.internalSearch;

                            // Check if qualifies for resident discount
                            if (!params.isInspirationalSearch) {
                                Odigeo.requireWidget('resident-discount', 'residentdiscount', function(widget) {
                                    residentIATAs = widget.options.residentZones;

                                    if (!Odigeo._.isEmpty(residentIATAs)) {
                                        iatas = Odigeo._.chain(params.searchSegments)
                                            .map(function(seg) {
                                                sameCountry = ((seg.departure.countryCode === seg.destination.countryCode) ||
                                                    (seg.departure.country === seg.destination.country));
                                                return [seg.departure.iata, seg.destination.iata];
                                            })
                                            .flatten()
                                            .unique()
                                            .value();

                                        residentZones = Odigeo._.chain(residentIATAs)
                                            .pick(iatas)
                                            .values()
                                            .flatten()
                                            .unique()
                                            .value();
                                    }
                                });
                            }

                            if (!residentZones.length || (params.numInfants + params.numChildren > 0) || params.type === 'multipleTrip') {
                                params = Odigeo._.omit(params, 'resident');
                            }

                            currentSearchSingletonModel.getInstance().set(params);

                            var options = '';
                            var page;
                            var comesFromPassenger = false;
                            if (!Odigeo._.isUndefined(params.comesFromPassenger) && params.comesFromPassenger) {
                                comesFromPassenger = params.comesFromPassenger;
                                params = Odigeo._.omit(params, 'comesFromPassenger');
                            }

                            var searchParams = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
                            if (searchParams && searchParams.type === 'oneWayTrip') {
                                Odigeo.requireWidget('calendar-grid', 'calendar_grid', function(widget) {
                                    widget.execute('refreshData');
                                });
                            }

                            // Redirect to Resident Discount page
                            if (params.isInspirationalSearch) {
                                page = 'inspirational';
                            } else if (!Odigeo.AB.isResidentDiscount && sameCountry && residentZones.length && (params.type !== 'multipleTrip') &&
                                (params.numInfants + params.numChildren === 0)) {
                                page = residentPage;
                            } else {
                                page = resultPage;
                                options = {
                                    params: stringifierFun(params),
                                    replace: pageName === resultPage || comesFromPassenger,
                                    isSecured: false,
                                };
                                asyncWidgets.getResultsManager().execute('clearPrimeFilter', true);
                                if (location.pathname.indexOf(Odigeo.Settings.getProperty('pathApiSearchplugin')) === -1) {
                                    // Replace if we are in results, push otherwise
                                    page = resultPage;
                                    options = {
                                        isSecured: false,
                                        replace: pageName === resultPage || comesFromPassenger,
                                        params: stringifierFun(params, resultPage),
                                    };
                                } else {
                                    Odigeo.Router.goFromExternal(resultPage,
                                        stringifierFun(params, resultPage));
                                }
                            }
                            var newTabUrl = window.location.protocol + '//' + window.location.host + Odigeo.Settings.property('appContext') +
                                '#' + page + '/' + (options.params ? options.params : '');
                            if (params.isNewTab) {
                                var tab = window.open(decodeURIComponent(newTabUrl));
                                didTabClose(tab, 250).then(Odigeo._.bind(function(hasClosed) {
                                    if (hasClosed) {
                                        trackingUtils.trackEvent('searcher_flights', 'new_tab_blocked');
                                        Odigeo.Router.navigate(page, options);
                                    } else {
                                        trackingUtils.trackEvent('searcher_flights', 'new_tab_continue');
                                    }
                                }, this));
                            } else {
                                Odigeo.Router.navigate(page, options);
                            }
                        },

                        onDynpackSearch: function(data) {
                            if (data.newRoomFormat !== true) {
                                Odigeo._.extend(data, Accommodations.getPaxNumBasedOnRooms(data.rooms, data.numberOfRooms));
                            }
                            this.onSearch(
                                Odigeo._.omit(data, 'newRoomFormat'),
                                dpresultsNavigation.getFirstRoute(),
                                Dynpack.searchParamsStringify
                            );
                        },

                        onFlightManagerSearch: function(data) {
                            this.onSearch(data);
                        },

                        onDynpackSearchFromFlights: function(data) {
                            Odigeo._.extend(data, Accommodations.allocateRooms(data));
                            this.onSearch(
                                Odigeo._.omit(data, 'newRoomFormat'),
                                dpresultsNavigation.getFirstRoute(),
                                Dynpack.searchParamsStringify
                            );
                        },

                        onPreSearchPerformed: function() {
                            // Check if this is the first search in order to show Lucky layer on previoussearches
                            previousSearchesHeaderWidget().execute('setHasToShowLuckyLayer');
                        },

                        onStoreSearch: function(fullData) {
                            // Store data of the search in Local Storage
                            Odigeo.requireWidget('previous-searches', 'previoussearches', function(previoussearches) {
                                previoussearches.execute('storeData', fullData);
                            });
                        },

                        onPrepareSearchSummary: function(fullData) {
                            // Prepare searchsummary in the result page for a new search
                            Odigeo.requireWidget('page-title', 'page_title', function(widget) {
                                widget.execute('refresh');
                            });

                            // Prepare searchsummary in the result page for a new search
                            Odigeo.requireWidget('results-search-summary', 'searchsummary', function(widget) {
                                widget.execute('refresh');
                            });
                        },
                        onPrepareCalendarGrid(searchParameter) {
                            const {type, searchSegments} = searchParameter || {};
                            const departureDate = new Date(searchSegments[0].dateStr).getTime();
                            const isValidDate = Odigeo.Utils.getDifferenceInDays(Date.now(), departureDate) >= 0;
                            if (type === 'oneWayTrip' && isValidDate) {
                                Odigeo.requireWidget('calendar-grid', 'calendar_grid', function(widget) {
                                    widget.execute('refreshData');
                                });
                            }
                        },

                        onPrepareResultsManager: function(fullData) {
                            // Prepare fullprice-manager in the result page for a new search
                            Odigeo.requireWidget('fullprice-manager', 'full_price_manager', function(widget) {
                                widget.execute('loadSelectorBaggage', fullData);
                            });

                            // Fill Waiting Flight Info & init Counter
                            Odigeo.trigger('fillWaitingPage', fullData);
                            Odigeo.UIElements.enhanceCounter('#numbers-combinations', 100, 1250000, 0, 20);

                            // Hide searchPanel and collapse filters
                            Odigeo.trigger('collapseSearchPanel');
                            Odigeo.trigger('collapseFilters');
                        },

                        onShowWaitingPage: function() {
                            // Show loading
                            if (Odigeo.AB.isFixWaitingPageDesktop) {
                                $header.removeClass('odf-hidden');
                                $footer.removeClass('odf-hidden');
                            }
                            if (Odigeo.SessionScope.isSkeletonWaitingDesktop) {
                                Odigeo.trigger('loading:show', 1);
                                const $changeSearch = $('#one-line-search-manager');
                                const $footer = $('#footer-wrapper');
                                const $calendarGrid = $('.calendargrid_wrapper');
                                $changeSearch.addClass('odf-hidden');
                                $footer.addClass('odf-hidden');
                                $calendarGrid.addClass('odf-hidden');
                            } else {
                                Odigeo.UIElements.enhanceLoading($('.waiting_page'))
                                    .showLoading(['waiting_searching',
                                        'waiting_connection_container',
                                        'waiting_bottom_gradient',
                                        'waiting_ad_box']);
                            }
                            $('#campaign_countdown_container').toggleClass('odf-hidden', true);
                        },

                        onAnalyticsTrackingEvents: function(fullData) {
                            if (fullData.buyPath && fullData.buyPath.indexOf('HOME') > -1) {
                                // Analytics: event tracking
                                var page = isDynpack ? 'dynpack_tab' :
                                    (Odigeo.SessionScope.entryPoint === 'flights' ? 'flights_tab' : 'home');
                                trackingUtils.trackEvent('searcher_flights', 'number_pax_' + fullData.numAdults + '_' +
                                    fullData.numChildren + '_' + fullData.numInfants, page);

                                if (fullData.flexibleDates) {
                                    trackingUtils.trackEvent('searcher_flights', 'search_flexible_checked');
                                }
                                if (fullData.directFlightsOnly) {
                                    trackingUtils.trackEvent('searcher_flights', 'direct_flights_checked', page);
                                }
                            }
                        },

                        onSearchPerformed: function(fullData) {
                            Odigeo.requireWidget('search-manager', 'searchmanager', function(searchManager) {
                                searchManager.execute('throwSearchPerformedEvents', fullData);
                            });
                        },
                        onSearchError: function() {
                            var $searchContainer = $('.flightspage_section');
                            var $resultContainer = $searchContainer.find('#results-manager');
                            var $filtersContainer = $('#filters-manager');
                            var $breadCrumbsContainer = $('#bread-crumbs');

                            Odigeo.requireWidget('flights-manager', 'flightsmanager', function(widget) {
                                widget.execute('changeSearchButtonsState', false);
                            });

                            $resultContainer.addClass('hidden');
                            $filtersContainer.addClass('hidden');
                            $breadCrumbsContainer.addClass('hidden');
                            $('.filters_container, .page-title').addClass('hidden');

                            handleNoResultsError();

                            Odigeo._.delay(function() {
                                Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
                            }, 500);

                            // Analytics: virtual page error tracking
                            trackingUtils.trackPage('results', {
                                funnel: true,
                                error: {type: 'default', message: 'search_error'},
                            });
                        },
                        onSearchCompletedWithError: (errors) => {
                            const [searchError] = errors;

                            if (searchError.code === 'NO_ITINERARIES_RESULTS') {
                                handleNoResultsError();
                            } else {
                                Odigeo.UIElements.showBrokenFlowError();
                            }
                        },
                        onSearchCompletedSuccessfully: function(result) {
                            Odigeo.Storage.set('results_count', result.numResults);

                            // check the size of the response in extra params
                            if (result.numResults < 1) {
                                handleNoResultsError();
                            } else {
                                $('.flightspage_section #results-manager').removeClass('hidden');
                                $('.filters_container, .page-title').removeClass('hidden');

                                // Load filters
                                Odigeo.requireWidget('filters-manager', 'filters_manager', function(widget) {
                                    widget.execute('loadFilters');
                                    $('#filters-manager, .filters_container').removeClass('hidden');
                                });

                                // Set flexible dates widget. New functionality only available for Bluestone.
                                var searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
                                result.tripType = Odigeo._.isNull(searchParameters) ? null : searchParameters.type;
                                Odigeo.requireWidget('flexible-dates', 'flexible_dates', function(widget) {
                                    widget.execute('updateView', Odigeo._.pick(result,
                                        'cheapestItineraryPrice',
                                        'fastestItineraryTaggingPrice',
                                        'maxDurationThreshold',
                                        'slowFlightsTaggingTabEnabled',
                                        'tripType',
                                        'cheapestItineraryProviderPrice',
                                        'cheapestItinerarySH',
                                        'cheapestItineraryCollectionMethodPrice',
                                        'firstSortedByDurationTaggingPrice'
                                    ));
                                });
                                if (searchParameters && result.tripType === 'oneWayTrip') {
                                    Odigeo.requireWidget('calendar-grid', 'calendar_grid', function(widget) {
                                        widget.execute('refreshSearchPrice');
                                    });
                                }
                            }
                        },
                        onSearchMapiCompletedWithError: function(landingPageType) {
                            if (landingPageType === 'PASSENGER') {
                                var search = JSON.parse(Odigeo.Session.get('searchParameters'));
                                Odigeo.requireWidget('search-manager', 'searchmanager', function(searchManager) {
                                    searchManager.execute('performSearch', {
                                        params: Flights.searchParamsStringify(search),
                                    });
                                });
                            } else if (Odigeo.History.getPageNameFromFragment() === 'results') {
                                this.onSearchCompletedWithError();
                            }
                        },
                        onStartMapiMetric: function(landingPageType) {
                            var landingMetric = {
                                RESULT: 'LOAD_META_RESULTS',
                                PASSENGER: 'LOAD_META_PASSENGERS',
                                INTERMEDIATE: 'LOAD_META_INTERMEDIATE',
                            };
                            trackingUtils.startMetric(landingMetric[landingPageType]);
                            if (landingPageType === 'PASSENGER') {
                                trackingUtils.startMetric(landingMetric.INTERMEDIATE);
                            }
                        },

                        onSearchMapiCompletedSuccessfully: function(landingPageType, result) {
                            const isPriceWithoutDiscountSelected = landingPageType === 'PASSENGER';
                            setProductNameInSession(result.transportType);
                            Odigeo.Session.set('repricingMAPI', JSON.stringify(result.repricing));
                            Odigeo.Session.set('bookingId', result.bookingId);
                            if (landingPageType === 'PASSENGER') {
                                this.goToDetailsPageMapi(result.bookingId, isPriceWithoutDiscountSelected);
                            } else if (landingPageType === 'INTERMEDIATE') {
                                this.goToIntermediatePageMapi(result);
                            } else {
                                this.onSearchCompletedSuccessfully(result);
                            }
                        },

                        goToIntermediatePageMapi: function(result) {
                            const searchId = result.searchId;
                            const searchData = Flights.getSearchData();
                            let flightData;
                            let getSegmentKeys = function(segmentKeys) {
                                const parsedKeys = [];

                                Odigeo._.forEach(segmentKeys, function(item) {
                                    parsedKeys.push(item.split(',', 1));
                                });

                                return Odigeo._.flatten(parsedKeys);
                            };

                            searchData.then(function(data) {
                                flightData = {
                                    data: {
                                        'fareItineraryKey': data.externalSelectionRequest.fareItineraryKey,
                                        'segmentKeys': getSegmentKeys(data.externalSelectionRequest.segmentKeys),
                                        'searchId': searchId,
                                    },
                                    flightNumbers: data.externalSelectionRequest.segmentKeys,
                                };
                                Odigeo.Session.set('flightSelectionData', JSON.stringify(flightData));
                                Odigeo.Session.set('intPageAccommodationResults', JSON.stringify(result));
                                Odigeo.Session.set('isMetaForIntermediate', true);
                                Odigeo.Session.set('isAccommodationPostBooking', false);
                                Odigeo.Router.navigate('xsellproductselection');
                            });
                        },

                        goToDetailsPageMapi: function(bookingId, isPriceWithoutDiscountSelected) {
                            const searchData = Flights.getSearchData();
                            let flightData;

                            searchData.then(function(data) {
                                flightData = {
                                    data: {
                                        'fareItineraryKey': data.externalSelectionRequest.fareItineraryKey,
                                        'segmentKeys': data.externalSelectionRequest.segmentKeys,
                                        'searchId': data.externalSelectionRequest.searchId,
                                        'priceWithoutDiscountSelected': isPriceWithoutDiscountSelected,
                                    },
                                    flightNumbers: data.externalSelectionRequest.segmentKeys,
                                };

                                Odigeo.Session.set('flightSelectionData', JSON.stringify(flightData));
                                if (Odigeo.AB.isFecoCheckoutPassengersDesktopMeta) {
                                    Odigeo.Router.navigate(`checkout_passengers`, {bookingId});
                                } else {
                                    Odigeo.Router.navigate(`details`, {bookingId});
                                }
                            });
                        },

                        onTrackAutocomplete: function(data) {
                            var isDynpackTabActive = $('#flights-manager').find('.flightsManager_tab.active').data('value') === 'dp';
                            trackingUtils.trackEvent(data.action +
                                (isDynpackTabActive ? 'dynpack' : 'flights'), data.label, data.page);
                        },

                        allowToRefreshResults: function(allowed) {
                            asyncWidgets.getResultsManager().execute('allowToRefresh', allowed);
                        },

                        doCheckNonStopsFilter: function(param) {
                            widgets.stopoverQuantityFilter(param.tabId).execute('doCheckNonStopsFilter', param);
                        },

                        updateStopoverDurationFilter: function(idx, fMetadata) {
                            widgets.stopoverDurationFilter(idx).execute('updateFilter', idx, fMetadata);
                        },

                        updateTimeFilter: function(idx, fMetadata, isActiveleg) {
                            widgets.timeFilter(idx).execute('updateFilter', idx, fMetadata, isActiveleg);
                        },

                        updateFlightDurationFilter: function(idx, fMetadata) {
                            widgets.flightDurationFilter(idx).execute('updateFilter', idx, fMetadata);
                        },

                        updateAirlinesFilter: function(idx, fMetadata, $cachedSelectors) {
                            widgets.airlinesFilter(idx).execute('updateFilter', idx, fMetadata, $cachedSelectors);
                        },

                        updateAirportsFilter: function(idx, fMetadata) {
                            widgets.airportsFilter(idx).execute('updateFilter', idx, fMetadata);
                        },

                        initFilterByCities: function() {
                            asyncWidgets.getFilterByCities();
                        },
                    },
                },
                advertisementEventController: {
                    eventHandlers: {
                        advertisementLoadData: function() {
                            Odigeo.trigger(Odigeo.Utils.getAppInGlobalScope() + '-product:data-loaded');
                            var advertisementListGpt = $('#modtop, #modsky1, #modsky2');
                            // Advertising
                            this.enhaceAdvertisementGpt(advertisementListGpt);
                        },
                        dynpackAdvertisementLoadData: function(adGptSelectors, travelAudienceAddBlocks) {
                            Odigeo.trigger(Odigeo.Utils.getAppInGlobalScope() + '-product:data-loaded');

                            var advertisementListTravelAudience = [];
                            if (Odigeo.SessionScope.ads && Odigeo.SessionScope.ads.travelAudience) {
                                Odigeo._.each(travelAudienceAddBlocks, function(block) {
                                    advertisementListTravelAudience.push(block);
                                });
                            }
                            // Advertising
                            this.enhaceAdvertisementGpt($('#modtop ,' + adGptSelectors));
                            this.setAdsOnTravelAudience(advertisementListTravelAudience);
                        },
                        enhaceAdvertisementGpt: function(advertisementListGpt) {
                            if (advertisementListGpt.length > 0) {
                                Odigeo.UIElements.enhanceAdvertisementGpt(advertisementListGpt, true, true, true);
                            }
                        },
                        setAdsOnTravelAudience: function(advertisementListTravelAudience) {
                            if (advertisementListTravelAudience.length > 0) {
                                Odigeo.Utils.Advertisement.TravelAudience.setAdsOn(advertisementListTravelAudience,
                                    Odigeo.SessionScope.ads.travelAudience);
                            }
                        },
                    },
                },
            }),
        },
        templatesManager: templatesManager,
    };
    Odigeo.start(odigeoStartConfig);

    shoppingCart.restore();
}
